/**
 * Demo mode lets the app run with an in-memory sample dataset instead of a live
 * Firebase backend. It exists so the UI can be developed, reviewed and
 * screenshotted without credentials or emulator access.
 *
 * Enable it with `VITE_DEMO_MODE=true` (see `npm run dev:demo`).
 *
 * This is a module-level constant fed by a statically replaced env var, so
 * production bundles fold it to `false` and tree-shake the sample data away.
 */
export const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true'

/** Latency applied to demo reads so loading states remain visible and testable. */
export const DEMO_LATENCY_MS = 180
